<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <router-link class="col04" to="/HelpCenter">帮助中心<span class="plr5">/</span></router-link>
            <div class="now_page">帮助中心详情</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="7" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="title_box flex-box flex-between">
                    <div class=" fs18 col04 fwb">新手指南-安全采购</div>
                    <div class="back fs16 col12 cursor flex-box" @click="$router.go(-1)">返回</div>
                </div>
                <div class="item flex-box mb30">
                    <div class="index fs16 col12">Q{{ index  }}</div>
                    <div class="flex-grow-1 fs16 col12 m-ellipsis">{{detail.name}}</div>
                </div>
                <div class="fs16 col04" v-html="detail.content"></div>
                <!-- <div class="link_box flex-box flex-wrap">
                    <div class="link_item fs14 coleb">《互联网药品交易服务机构资格证书》</div>
                    <div class="link_item fs14 coleb">《互联网药品交易服务机构资格证书》</div>
                    <div class="link_item fs14 coleb">《互联网药品交易服务机构资格证书》</div>
                    <div class="link_item fs14 coleb">《互联网药品交易服务机构资格证书》</div>
                    <div class="link_item fs14 coleb">《互联网药品交易服务机构资格证书》</div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "帮助中心详情-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            index: 0,
            detail: {},
        };
    },
    created() {
        let id = this.$route.query.id;
        this.index = this.$route.query.index;
        this.getDetail(id);
    },
    methods: {
        getDetail(id) {
            this.$api.getHelpDetail({ id: id }).then(res => {
                this.detail = res.data;
            }).catch(err => {
                console.log(err);
            })
        }
    },
};
</script>

<style lang="less" scoped>
.back::before {
    content: "";
    display: block;
    width: 27px;
    height: 24px;
    background: url('/src/assets/static/icon/c_back.png') no-repeat center;
    background-size: 100%;
    margin-right: 10px;
}

.part_r {
    padding: 0 44px 44px;
    background-color: #fff;

    .title_box {
        padding: 41px 0 32px;
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);
        margin-bottom: 24px;
    }

    .item {
        width: 1000px;
        height: 68px;
        background: #F7FAFF;
        padding: 0 44px 0 24px;

        .index {
            width: 44px;
            height: 44px;
            background: #FFFFFF;
            text-align: center;
            line-height: 44px;
            border-radius: 50%;
            margin-right: 15px;
        }

    }

    .link_box {
        width: 1000px;
        height: 94px;
        background: rgba(254, 184, 51, 0.04);
        border-radius: 10px;
        border: 2px solid rgba(254, 184, 51, 0.6);
        padding: 0 20px;
        margin-top: 15px;

        .link_item {
            width: 33.333%;
        }
    }
}
</style>
